<template>
  <div class="scale-input" @click.stop>
    <div class="scale-input__icon">
      <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="5.24994" cy="5.24994" r="4.74994" stroke="currentColor"/>
        <path d="M8.62427 8.625L11.9992 12" stroke="currentColor"/>
        <path d="M3.09253 5.25757H7.42234" stroke="currentColor"/>
        <path d="M5.25732 3.09277V7.42258" stroke="currentColor"/>
      </svg>
    </div>
    <ul class="scale-input__list">
      <li class="scale-input__item" v-for="(option) in scaleOptions" :key="option.id"
                                    :class="option.active ? 'active' : ''"
                                    @click="setScale(option.id)">
        {{ option.text }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'app-scale',
  props: {
    scaleOptions: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    setScale (optionId) {
      this.$emit('set-scale', optionId)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.scale-input {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  width: fit-content;

  &__icon {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    @include size(30px);
    color: $font_color_alt;
    background: $color_second-light;
    padding: 8px;
    border-radius: 3px 0 0 3px;
  }

  &__list {
    display: flex;
    flex-flow: row nowrap;
    background: $color_sixth;
    border-radius: 0 3px 3px 0;
    padding: 0 8px;
  }

  &__item {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    transition: .3s;
    color: $font_color_third;
    opacity: .5;
    margin-right: 12px;
    cursor: pointer;

    &:hover {
      opacity: 1;
    }

    &.active {
      opacity: 1;
    }

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
